
import {
    defineComponent,
} from "vue";
import dayjs from "dayjs";
import ListManager from "@/components/cigo-admin-core/pages/template/ListManager.vue";
import EditUser from "@/components/cigo-admin-core/pages/auth/edit/EditUser.vue";
import {
    User
} from "@/components/cigo-admin-core/utils/types";
import {
    showImg,
    showSex
} from "@/components/cigo-admin-core/utils/edit";

export default defineComponent({
    name: "CigoUser",
    components: {
        ListManager
    },
    setup(props) {
        const columns = [{
                title: "编号",
                dataIndex: "id",
                width: "80px"
            },
            {
                title: "头像",
                dataIndex: "img",
                width: "80px",
                slots: {
                    customRender: "img"
                }
            },
            {
                title: "用户名",
                dataIndex: "username",
                width: "100px"
            },
            {
                title: "是否在线",
                dataIndex: "is_online",
                width: "100px",
                slots: {
                    customRender: "isOnline"
                }
            },
            {
                title: "最后登录时间",
                dataIndex: "last_log_time",
                width: "180px",
                slots: {
                    customRender: "lastLogTime"
                }
            },
            {
                title: "手机号",
                dataIndex: "phone",
                width: "150px"
            },
            {
                title: "Email",
                dataIndex: "email",
                width: "180px"
            },
            {
                title: "昵称",
                dataIndex: "nickname",
                width: "100px"
            },
            {
                title: "姓名",
                dataIndex: "realname",
                width: "100px"
            },
            {
                title: "性别",
                dataIndex: "sex",
                width: "100px",
                slots: {
                    customRender: "sex"
                }
            },
            {
                title: "注册时间",
                dataIndex: "create_time",
                width: "180px",
                slots: {
                    customRender: "createTime"
                }
            },
        ];
        let columnsSlots = [{
                slot: "img"
            },
            {
                slot: "isOnline"
            },
            {
                slot: "lastLogTime"
            },
            {
                slot: "sex"
            },
            {
                slot: "createTime"
            }
        ];

        return {
            dayjs,
            columns,
            columnsSlots,
            EditUser,
            showSex,
            showImg
        };
    }
});
